<template>
  <div style="width: 100%; height: 100%" v-loading="loading"></div>
</template>

<script>
// import _ from 'lodash'
import qs from 'qs'
export default {
  props: [],

  components: {},

  data() {
    return {
      loading: true
    }
  },

  watch: {},

  computed: {},

  mounted() {
    this.initAlterLogin()
  },

  methods: {
    initAlterLogin() {
      if (this.$route.query.code) {
        let param = {
          grant_type: 'password',
          identity_type: 6,
          code: this.$route.query.code,
          client_id: 'test',
          client_secret: 'MTIzNDU2'
        }
        this.$xhrPost('/auth/oauth/token', qs.stringify(param), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }).then(rs => {
          this.loading = false
          this.error = []
          if (rs && rs.access_token) {
            window.localStorage.setItem('token', rs.access_token)
            window.localStorage.setItem('refreshToken', rs.refresh_token)
            this.$xhrGet(`/acc/whoami`).then(rs => {
              this.loading = false
              if (rs.code === 'SUCCESS') {
                this.$store.commit('user/login', rs.data)
                let city =
                  rs.data.role === 'screen_viewer' && rs.data.level === 1
                let district =
                  rs.data.role === 'screen_viewer' && rs.data.level === 2
                let school =
                  rs.data.role === 'screen_viewer' &&
                  rs.data.level === null &&
                  rs.data.grade === null
                if (city) {
                  this.$router.push({
                    name: 'ScreenHome'
                  })
                } else if (district) {
                  this.$router.push({
                    name: 'DistrictAnalysis',
                    query: {
                      city: rs.data.region.name,
                      val: rs.data.region.value
                    }
                  })
                } else if (school) {
                  this.$router.push({
                    name: 'SchoolAnalysis'
                  })
                }
              }
            })
          } else if (rs.error && rs.error_description === 'auth_error') {
            this.alterLoginLoading = false
            this.$message.error('未知用户，请先添加或联系管理员')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'user_locked') {
            this.alterLoginLoading = false
            this.$message.error('用户已锁定')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'unsupported_role') {
            this.alterLoginLoading = false
            this.$message.error('角色无权限')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'illegal_visit') {
            this.alterLoginLoading = false
            this.$message.error('授权失败')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'user_locked') {
            this.alterLoginLoading = false
            this.$message.error('用户已锁定')
            this.$router.push({ name: 'Login' })
          } else if (rs.error && rs.error_description === 'role_error') {
            this.alterLoginLoading = false
            this.$message.error('用户角色错误')
            this.$router.push({ name: 'Login' })
          }
        })
      } else {
        this.alterLoginLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/RedirectHengshui.vue